export default {"src":"/polygon/_next/static/media/blockchain.b3d12826.svg","height":26,"width":26};